// Sentralisert datakilde for alle nyheter.
// Når du legger til en ny nyhetsartikkel her, dukker den automatisk opp:
//   - På forsiden (3 nyeste, sortert etter sortDate)
//   - I /nyheter-arkivet (alle, sortert nyest først)
//   - På /nyheter/<slug> (full artikkel)

export const newsArticles = [
  {
    id: 10,
    slug: 'til-minne-om-kong-harald',
    title: 'Til minne om Hans Majestet Kong Harald',
    excerpt:
      'Det er med stor sorg vi har mottatt budskapet om Hans Majestet Kong Haralds bortgang. På vegne av Veitvet Sportsklubb uttrykker vi vår dypeste medfølelse med Dronningen, Kongefamilien og alle som sto Kong Harald nær.',
    date: '28. august 2026',
    sortDate: '2026-08-28',
    category: 'Klubbinfo',
    image:
      'https://customer-assets-4nw71qhi.emergentagent.net/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/3urwgndp_KongHarald.webp',
    imageStyle: 'cover',
    featured: true,
    content: `
      <div class="border-l-4 border-slate-900 pl-6 my-8">
        <p class="text-slate-500 text-sm uppercase tracking-widest mb-2">In memoriam</p>
        <h2 class="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight leading-tight">Hans Majestet Kong Harald</h2>
      </div>

      <p class="text-xl text-slate-700 mb-8 leading-relaxed">Det er med stor sorg vi har mottatt budskapet om Hans Majestet Kong Haralds bortgang.</p>

      <p class="mb-6 text-slate-600 leading-relaxed">Kong Harald var en folkekjær konge og et samlende symbol for Norge. Han møtte mennesker med varme og nærhet, og hadde en sterk tro på fellesskapet og på at vi hører sammen.</p>

      <p class="mb-6 text-slate-600 leading-relaxed">Kong Harald hadde også et ektefølt engasjement for norsk idrett og frivillighet. Han var hele idrettens konge – fra barn og unge i den lokale breddeidretten til våre største idrettsprestasjoner. Vi er takknemlige for støtten og engasjementet han gjennom et langt liv viste norsk idrett og verdiene den representerer.</p>

      <p class="mb-10 text-slate-600 leading-relaxed">På vegne av Veitvet Sportsklubb uttrykker vi vår dypeste medfølelse med Dronningen, Kongefamilien og alle som sto Kong Harald nær.</p>

      <div class="border-t border-slate-200 pt-8 mt-10 text-center">
        <p class="text-2xl font-bold text-slate-900 italic">Takk for alt, Kong Harald.</p>
      </div>
    `,
  },
  {
    id: 9,
    slug: 'fritidskortet-oslo-friskus-2026',
    title: 'Fritidskortet i Oslo – økonomisk støtte til fritidsaktiviteter',
    excerpt:
      'Fra 17. august 2026 kan barn og unge (6–19 år) i Oslo få økonomisk støtte til fritidsaktiviteter gjennom det nye fritidskortet. Ordningen administreres av Oslo kommune og håndteres via Friskus.',
    date: '17. august 2026',
    sortDate: '2026-08-17',
    category: 'Klubbinfo',
    image:
      'https://customer-assets-4nw71qhi.emergentagent.net/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/na10kfvn_Logo.png',
    imageStyle: 'cover',
    featured: true,
    content: `
      <p class="text-xl text-slate-600 mb-6">Fra <strong class="text-green-500">17. august 2026</strong> er Oslo kommunes nye fritidskort tilgjengelig – en økonomisk støtteordning som skal bidra til at flere barn og unge får mulighet til å delta i organiserte fritidsaktiviteter innen idrett, kultur og friluftsliv.</p>

      <p class="mb-6">Ordningen administreres av <strong>Oslo kommune</strong>, mens selve fritidskortet og betaling av aktiviteter håndteres gjennom <strong>Friskus</strong>.</p>

      <div class="bg-blue-500/10 border-l-4 border-blue-500 rounded-r-xl p-6 my-8">
        <h3 class="text-xl font-bold text-slate-900 mb-3">📌 Viktig: Friskus er ikke innmelding i klubben</h3>
        <p class="text-slate-700 mb-3">Å <strong>finne, registrere eller "melde seg på"</strong> en aktivitet i Friskus er <strong>ikke</strong> det samme som å bli medlem av Veitvet SK.</p>
        <p class="text-slate-700 mb-3">For å delta på en aktivitet hos oss må du:</p>
        <ol class="space-y-2 list-decimal list-inside text-slate-700 marker:font-bold marker:text-blue-600">
          <li>Først <strong>bli medlem av Veitvet SK</strong></li>
          <li>Deretter <strong>melde deg inn i den aktuelle idretten eller aktiviteten</strong> du ønsker å delta på</li>
        </ol>
        <p class="text-slate-700 mt-3">Selve innmeldingen skjer gjennom <strong>klubbens medlemssystem (Hoopit)</strong> – ikke via Friskus. Friskus brukes kun til <strong>å betale</strong> medlemsavgift eller treningsavgift med midler fra Fritidskortet.</p>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hvem kan få fritidskort?</h2>
      <p class="mb-4 text-slate-600">Barn og unge mellom <strong>6 og 19 år</strong> med folkeregistrert adresse i Oslo kan få fritidskort. Størrelsen på støtten avhenger av foresattes samlede inntekt og barnets alder.</p>

      <div class="grid sm:grid-cols-2 gap-4 my-8">
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-2">Høsten 2026</p>
          <p class="text-xl font-bold text-slate-900">6–12 år</p>
          <p class="text-slate-600 text-sm mt-1">1 100 – 1 650 kroner</p>
        </div>
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-2">Høsten 2026</p>
          <p class="text-xl font-bold text-slate-900">13–19 år</p>
          <p class="text-slate-600 text-sm mt-1">1 650 – 2 450 kroner</p>
        </div>
      </div>

      <p class="mb-6 text-slate-600">Foresatte og barn over 15 år kan søke. Det er <strong>ingen søknadsfrist</strong>, og søknaden behandles automatisk av Oslo kommune – du får derfor normalt svar med en gang.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hvordan fungerer det?</h2>
      <ol class="space-y-3 mb-8 list-decimal list-inside text-slate-600 dark:text-slate-300 marker:text-green-500 marker:font-bold">
        <li>Søk om fritidskort gjennom Oslo kommune</li>
        <li>Dersom søknaden innvilges, får du svar med en gang</li>
        <li>Bli medlem i Veitvet SK og meld deg inn i den aktuelle aktiviteten gjennom klubbens medlemssystem (Hoopit)</li>
        <li>Vent til du mottar en <strong>faktura fra Veitvet SK / Hoopit</strong> for medlems- og/eller treningsavgift</li>
        <li>Opprett bruker eller logg inn på Friskus</li>
        <li>Betal fakturaen i Friskus ved å bruke <strong>KID-nummeret</strong> fra Hoopit-fakturaen</li>
        <li>Velg hvor mye av fritidskortet du ønsker å bruke til betalingen</li>
        <li>Dersom fritidskortet ikke dekker hele beløpet, betaler du resten på vanlig måte</li>
      </ol>

      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5 my-6">
        <p class="text-slate-700"><strong class="text-green-600">Automatisk registrering:</strong> Når du betaler en Hoopit-faktura direkte med Fritidskortet i Friskus (via KID-nummer), blir betalingen registrert automatisk. Klubben trenger ikke å registrere betalingen manuelt.</p>
      </div>

      <div class="bg-yellow-500/10 border-l-4 border-yellow-500 rounded-r-xl p-6 my-8">
        <h3 class="text-xl font-bold text-slate-900 mb-2">📅 Fritidskortet gjelder per kalenderår</h3>
        <p class="text-slate-700 mb-3">Fritidskortet i Friskus følger kalenderåret. Det betyr at Fritidskortet og midlene som tildeles for <strong>2026 kun gjelder for kalenderåret 2026</strong>. For 2027 må det søkes på nytt, og nye midler vil da være knyttet til kalenderåret 2027.</p>
        <p class="text-slate-700">Veitvet Sportsklubbs <strong>medlemskontingent og treningsavgifter følger også kalenderåret</strong> – medlems- og treningsavgift for 2026 gjelder for 2026, og det kommer nye avgifter for 2027. Dette er viktig å være klar over når Fritidskortet skal brukes til å betale kontingent eller treningsavgift.</p>
      </div>

      <div class="bg-yellow-500/10 border-l-4 border-yellow-500 rounded-r-xl p-6 my-8">
        <h3 class="text-xl font-bold text-slate-900 mb-2">⚠️ Viktig før du betaler medlems- eller treningsavgiften</h3>
        <p class="text-slate-700 mb-3">Dersom du ønsker å bruke fritidskortet til å betale en kommende avgift hos oss, er det viktig at du <strong>ikke betaler den aktuelle fakturaen på forhånd</strong>.</p>
        <p class="text-slate-700">Vent med betalingen slik at du kan bruke fritidskortet gjennom Friskus når fakturaen er tilgjengelig.</p>
      </div>

      <div class="bg-red-500/10 border border-red-500/30 rounded-xl p-5 my-6">
        <p class="text-slate-700 text-sm"><strong class="text-red-600">Merk:</strong> Fritidskortet kan <strong>ikke</strong> brukes til å få refundert avgifter som allerede er betalt. Trenger du en faktura for å bruke Fritidskortet, kan du <a href="/kontakt" class="text-red-600 hover:text-red-700 underline font-semibold">kontakte klubben</a>.</p>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hva kan fritidskortet brukes til?</h2>
      <p class="mb-4 text-slate-600">Fritidskortet kan blant annet brukes til:</p>
      <ul class="space-y-3 mb-6">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Medlems- og kursavgifter for godkjente aktiviteter som går over minst tre måneder
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Enkelte aktiviteter som cuper og konkurranser
        </li>
      </ul>

      <p class="mb-6 text-slate-600">Fritidskortet kan <strong>ikke</strong> brukes til treningsutstyr som fotballsko eller annet personlig utstyr.</p>

      <p class="mb-8 text-slate-600">Vi jobber med å registrere og oppdatere våre aktiviteter og tilbud i Friskus, slik at foresatte som får innvilget fritidskort kan benytte støtten på aktiviteter som omfattes av ordningen.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Søk og les mer</h2>
      <div class="grid gap-3 my-6">
        <a href="https://www.oslo.kommune.no/fritidskort" target="_blank" rel="noopener noreferrer" class="bg-slate-100 hover:bg-green-500/10 border border-slate-200 hover:border-green-500 rounded-xl p-4 transition-colors">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Oslo kommune</p>
          <p class="text-slate-900 font-semibold">Fritidskort for barn og unge →</p>
        </a>
        <a href="https://oslo-fritidskort.friskus.com/fritidskortet" target="_blank" rel="noopener noreferrer" class="bg-slate-100 hover:bg-green-500/10 border border-slate-200 hover:border-green-500 rounded-xl p-4 transition-colors">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Friskus</p>
          <p class="text-slate-900 font-semibold">Fritidskortet på Friskus →</p>
        </a>
        <a href="https://www.oslo.kommune.no/natur-kultur-og-fritid/fritidskort-for-barn-og-unge/sok-om-fritidskort/" target="_blank" rel="noopener noreferrer" class="bg-slate-100 hover:bg-green-500/10 border border-slate-200 hover:border-green-500 rounded-xl p-4 transition-colors">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Oslo kommune</p>
          <p class="text-slate-900 font-semibold">Slik søker du om fritidskort →</p>
        </a>
        <a href="https://support.hoopit.io/nb/articles/4825773-betale-med-fritidskort-i-hoopit" target="_blank" rel="noopener noreferrer" class="bg-slate-100 hover:bg-green-500/10 border border-slate-200 hover:border-green-500 rounded-xl p-4 transition-colors">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Hoopit Support</p>
          <p class="text-slate-900 font-semibold">Betale en Hoopit-faktura med Fritidskortet →</p>
        </a>
        <a href="https://www.oslo.kommune.no/natur-kultur-og-fritid/fritidskort-for-barn-og-unge/slik-bruker-du-fritidskortet/" target="_blank" rel="noopener noreferrer" class="bg-slate-100 hover:bg-green-500/10 border border-slate-200 hover:border-green-500 rounded-xl p-4 transition-colors">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Oslo kommune</p>
          <p class="text-slate-900 font-semibold">Slik bruker du fritidskortet →</p>
        </a>
      </div>

      <div class="bg-green-500/10 border-l-4 border-green-500 rounded-r-xl p-6 my-8">
        <h3 class="text-lg font-bold text-slate-900 mb-2">Har du spørsmål?</h3>
        <p class="text-slate-700 mb-2">Har du spørsmål om våre aktiviteter, fakturaer eller hvordan fritidskortet kan benyttes hos oss, er du velkommen til å <a href="/kontakt" class="text-green-600 hover:text-green-700 font-semibold underline">ta kontakt</a>.</p>
        <p class="text-slate-700">For spørsmål om søknaden, vedtaket eller selve fritidskortordningen, viser vi til Oslo kommune.</p>
      </div>

      <div class="bg-white border border-slate-200 rounded-xl p-6 my-8 text-center" data-testid="fritidskortet-guide-cta">
        <p class="text-slate-600 mb-4">Denne informasjonen finnes også som en fast veiledning på nettsiden vår, oppdatert etter hvert som ordningen endrer seg.</p>
        <a href="/fritidskortet" data-testid="fritidskortet-guide-link" class="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold uppercase tracking-wider px-6 py-3 rounded-lg transition-colors no-underline">Les den faste veiledningen →</a>
      </div>
    `,
  },
  {
    id: 8,
    slug: 'lokkefotball-2026',
    title: 'Løkkefotball 2026 – Gratis fotballglede for barn og ungdom',
    excerpt:
      'Vi inviterer barn og ungdom (6–16 år) til Løkkefotball 2026 – et gratis, inkluderende tilbud hver søndag fra 14. juni til 1. november. Ingen krav om medlemskap eller ferdighetsnivå.',
    date: '12. juni 2026',
    sortDate: '2026-06-12',
    category: 'Fotball',
    image:
      'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/0thbr6yl_Ball.jpg',
    imageStyle: 'cover',
    featured: true,
    content: `
      <p class="text-xl text-slate-600 mb-8">Vi er glade for å kunne invitere barn og ungdom til <strong class="text-green-500">Løkkefotball 2026</strong> – et gratis og inkluderende aktivitetstilbud med fokus på fotballglede, fellesskap og fysisk aktivitet.</p>

      <p class="mb-6">Løkkefotball er inspirert av den tradisjonelle «løkkefotballen», der barn og ungdom spiller fotball på egne premisser. Her er det <strong>ingen krav om medlemskap, faste lag eller ferdighetsnivå</strong>. Alle er velkomne, enten de spiller fotball hver dag eller bare har lyst til å være med og ha det gøy.</p>

      <div class="grid sm:grid-cols-2 gap-4 my-8">
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-2">Hvem</p>
          <p class="text-xl font-bold text-slate-900">Alle barn og ungdom</p>
          <p class="text-slate-600 text-sm mt-1">6–16 år</p>
        </div>
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-2">Når</p>
          <p class="text-xl font-bold text-slate-900">Hver søndag</p>
          <p class="text-slate-600 text-sm mt-1">14. juni – 1. november 2026<br/>Kl. 11.00–13.00</p>
          <p class="text-xs text-slate-500 mt-2 italic">Med forbehold om været</p>
        </div>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hva er målet?</h2>
      <p class="mb-4 text-slate-600">Vi ønsker å:</p>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Skape en trygg og inkluderende møteplass for barn og ungdom
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Bidra til mer fysisk aktivitet og bevegelsesglede
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Gi flere muligheten til å spille fotball uten krav og prestasjonspress
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Forebygge frafall fra idretten ved å tilby aktivitet på barnas egne premisser
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Styrke fellesskap, vennskap og tilhørighet i nærmiljøet
        </li>
      </ul>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hva kan du forvente?</h2>
      <p class="mb-4 text-slate-600">På Løkkefotball legger vi til rette for:</p>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Frispill og smålagsspill
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Enkle aktiviteter og fotballøvelser
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Mestring og utvikling for alle nivåer
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Trygge og engasjerte trenere og aktivitetsledere
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Et sosialt og inkluderende miljø
        </li>
      </ul>

      <p class="mb-6 text-slate-600">Gjennom sommeren vil vi også ved enkelte anledninger servere <strong>frukt og smoothie</strong> til deltakerne.</p>

      <div class="bg-green-500/10 border-l-4 border-green-500 rounded-r-xl p-6 my-8">
        <h3 class="text-xl font-bold text-slate-900 mb-2">Gratis deltakelse</h3>
        <p class="text-slate-700">Tilbudet er <strong>helt gratis</strong>, og det er bare å møte opp. Ta med fotballsko hvis du har, men det viktigste er godt humør og lyst til å være med.</p>
      </div>

      <p class="mb-8 text-slate-600">Vi gleder oss til å se både nye og kjente ansikter på banen!</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Har du spørsmål?</h2>
      <p class="mb-4 text-slate-600">Kontakt våre gruppeledere:</p>
      <div class="grid sm:grid-cols-2 gap-4 my-6">
        <div class="bg-slate-100 rounded-xl p-5">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Gruppeleder</p>
          <p class="text-lg font-bold text-slate-900">Ridwan Dahir Dahir Ahmed</p>
          <a href="tel:+4740840265" class="text-green-600 hover:text-green-700 font-semibold">+47 408 40 265</a>
        </div>
        <div class="bg-slate-100 rounded-xl p-5">
          <p class="text-xs text-slate-500 font-bold uppercase tracking-wider mb-1">Gruppeleder</p>
          <p class="text-lg font-bold text-slate-900">Ali Dahir Dahir Ahmed</p>
          <a href="tel:+4745887266" class="text-green-600 hover:text-green-700 font-semibold">+47 458 87 266</a>
        </div>
      </div>

      <p class="text-xl text-center font-bold text-green-600 mt-10 mb-4">Velkommen til Løkkefotball 2026! ⚽</p>
    `,
  },
  {
    id: 7,
    slug: 'fotballakademi-pamelding-2026',
    title: 'Veitvet Fotballakademi åpner påmeldingen!',
    excerpt:
      'Vil barnet ditt ha mer fotball, mer mestring og mer utvikling? Påmeldingen til Veitvet Barneakademi (6–12 år) og Veitvet Ungdomsakademi (13–16 år) er nå åpen.',
    date: '22. mai 2026',
    sortDate: '2026-05-22',
    category: 'Fotball',
    image:
      'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/fiqortth_Telenorxtra-crest-midblue-solid.png',
    imageStyle: 'contain',
    featured: true,
    content: `
      <p class="text-xl text-slate-600 mb-8">Vil barnet ditt ha <strong class="text-green-500">mer fotball, mer mestring og mer utvikling</strong>?</p>

      <p class="mb-6">Veitvet Fotballakademi er et ekstratilbud for barn og ungdom som ønsker flere treninger og mer fotballaktivitet utover den ordinære klubbhverdagen. Akademiet skal være et <strong>trygt, inkluderende og utviklende miljø</strong> der spillerne får utfordre seg selv, oppleve mestring og utvikle ferdighetene sine sammen med engasjerte trenere.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Nå åpner vi påmeldingen til:</h2>

      <div class="grid sm:grid-cols-2 gap-4 my-8">
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-2xl mb-2">⚽</p>
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-1">6–12 år</p>
          <p class="text-xl font-bold text-slate-900">Veitvet Barneakademi</p>
        </div>
        <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-5">
          <p class="text-2xl mb-2">⚽</p>
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-1">13–16 år</p>
          <p class="text-xl font-bold text-slate-900">Veitvet Ungdomsakademi</p>
        </div>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Gjennom akademiet tilbyr vi:</h2>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Teknisk og taktisk utvikling
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Mestring, læring og spilleglede
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Høy aktivitet og gode læringsmiljøer
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Engasjerte og kompetente trenere
        </li>
      </ul>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Meld deg på her:</h2>
      <div class="space-y-3 my-6">
        <a href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-6-12-ar-202627-374765" target="_blank" rel="noopener noreferrer" class="block bg-green-500/10 border border-green-500/30 hover:border-green-500 rounded-xl p-4 transition-all">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-1">6–12 år</p>
          <p class="font-bold text-slate-900">⚽ Veitvet Barneakademi – Meld deg på</p>
        </a>
        <a href="https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-13-16-ar-202627-510222" target="_blank" rel="noopener noreferrer" class="block bg-green-500/10 border border-green-500/30 hover:border-green-500 rounded-xl p-4 transition-all">
          <p class="text-xs text-green-600 font-bold uppercase tracking-wider mb-1">13–16 år</p>
          <p class="font-bold text-slate-900">⚽ Veitvet Ungdomsakademi – Meld deg på</p>
        </a>
      </div>

      <div class="bg-slate-100/50 border border-slate-200 rounded-xl p-5 my-6">
        <p class="text-slate-700 mb-2">Du kan lese mer om fotballakademiet her:</p>
        <a href="/fotball/barneakademi" class="text-green-500 hover:underline font-bold inline-block">→ Les mer om Barneakademiet</a>
        <span class="text-slate-400 mx-2">·</span>
        <a href="/fotball/ungdomsakademi" class="text-green-500 hover:underline font-bold inline-block">→ Les mer om Ungdomsakademiet</a>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Spørsmål?</h2>
      <p class="mb-3">Har du spørsmål om påmelding eller tilbudet? Ta gjerne kontakt med oss:</p>
      <p class="mb-2"><strong>E-post:</strong> <a href="mailto:fotballakademi@veitvet-sportsklubb.no" class="text-green-500 hover:underline">fotballakademi@veitvet-sportsklubb.no</a></p>
      <p class="mb-6"><strong>Telefon:</strong> <a href="tel:+4790083520" class="text-green-500 hover:underline">900 83 520</a></p>
    `,
  },
  {
    id: 6,
    slug: 'obos-naboklubb-valerenga-besok',
    title: 'Takk for en strålende dag med OBOS Naboklubb!',
    excerpt:
      'Tusen takk til alle som bidro til at OBOS Naboklubb-besøket hos Veitvet SK ble en fantastisk opplevelse. På bakgrunn av samarbeidet inviterer Vålerenga hele klubben til kamp på Intility Arena!',
    date: '22. april 2026',
    sortDate: '2026-04-22',
    category: 'Klubbnyheter',
    image:
      'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/3g874aen_7.png',
    imageStyle: 'cover',
    featured: false,
    content: `
      <p class="text-xl text-slate-600 mb-8">Tusen takk til alle som møtte opp og bidro til at OBOS Naboklubb-besøket hos Veitvet SK ble en fantastisk opplevelse!</p>

      <p class="mb-6">Det var utrolig gøy å se så mange barn og unge samlet til <strong class="text-green-500">aktivitet, mestring og ekte idrettsglede</strong>. Stemningen på banen var helt unik – og det er øyeblikk som dette som virkelig viser hva klubben vår handler om.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">En stor takk til alle bidragsyterne</h2>
      <p class="mb-6">En ekstra stor takk går til:</p>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          <span><strong class="text-slate-900 dark:text-white">Trenerne og laglederne</strong> som stilte opp og bidro til gjennomføringen</span>
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          <span><strong class="text-slate-900 dark:text-white">G19-spillerne</strong> som var flotte forbilder og bidro med energi og engasjement</span>
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          <span><strong class="text-slate-900 dark:text-white">Vålerenga Damer</strong> for besøket og en inspirerende økt for alle deltakerne</span>
        </li>
      </ul>

      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 text-lg italic">«Dere skapte en inspirerende og minnerik økt for alle deltakerne!»</p>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Veitvet på kamp – Intility Arena! 🎟️</h2>
      <p class="mb-6">På bakgrunn av samarbeidet med Vålerenga og Naboklubb-besøket, har Vålerenga gleden av å invitere <strong class="text-green-500">hele klubben</strong> til kamp på Intility Arena før sommeren:</p>

      <div class="bg-slate-100/50 rounded-xl p-6 my-8 border border-slate-200 dark:border-slate-700">
        <p class="text-slate-900 font-bold text-xl mb-2">Vålerenga vs. LSK Kvinner</p>
        <p class="text-slate-600 dark:text-slate-300 mb-1">📅 Lørdag 2. mai kl. 16:00</p>
        <p class="text-slate-600 dark:text-slate-300 mb-4">📍 Intility Arena</p>
        <p class="text-2xl font-bold text-green-500 mb-1">Promokode: heiaveitvet</p>
        <p class="text-slate-500 text-sm">Bruk koden ved bestilling for å hente dine billetter</p>
      </div>

      <p class="mb-6">Vålerenga kommer også tilbake med mer informasjon og et tilsvarende tilbud til kampen mot <strong class="text-green-500">Brann lørdag 13. juni kl. 16:00</strong> når billettene slippes.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Praktisk informasjon</h2>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Billetter kan bestilles av både individer og lag via lenken nedenfor
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Husk å bruke promokoden <strong class="text-green-500">heiaveitvet</strong> ved bestilling
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          <strong class="text-slate-900 dark:text-white">Free seating</strong> – alle kan sitte sammen med de de ønsker
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Venner og familie er hjertelig velkomne
        </li>
      </ul>

      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 text-lg italic">«Dette er en flott mulighet til å samle lagene og skape gode opplevelser sammen. Det aller viktigste er idrettsgleden, minnene og relasjonene vi bygger – både på og utenfor banen.»</p>
      </div>

      <p class="text-2xl font-bold text-green-500">Takk igjen til alle som bidro – vi gleder oss til fortsettelsen!</p>
    `,
    ctaButton: {
      label: 'Sikre dine billetter',
      url: 'https://vif-damefotball.ticketco.events/no/nb/e/vaalerenga__lsk_kvinner26',
    },
  },
  {
    id: 5,
    slug: 'social-run-club-sentrumslopet-2026',
    title: 'Social Run Club debuterte på Sentrumsløpet 2026!',
    excerpt:
      'Veitvet SK stilte tre medlemmer til start på årets Sentrumsløp 10K. Mounir, Antoinette og Nickolas representerte vår nyetablerte løpegruppe – og dette er bare starten!',
    date: '25. april 2026',
    sortDate: '2026-04-25',
    category: 'Klubbnyheter',
    image:
      'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/4vehwq5d_Sentrumsl%C3%B8pet%202026.jpg',
    imageStyle: 'cover',
    featured: false,
    content: `
      <p class="text-xl text-slate-600 mb-8">Social Run Club er i gang – og våre nyeste medlemmer viste virkelig hva fellesskap, glede og pågangsmot betyr da de tok turen til startstreken på Sentrumsløpet 2026!</p>

      <p class="mb-6">Veitvet SK stilte med tre stolte representanter på <strong class="text-green-500">10-kilometeren</strong> i sentrum av Oslo. Stemningen var topp, sola tittet frem og klubbfølelsen satt langt inne!</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Resultater fra Sentrumsløpet 2026 – 10K</h2>

      <div class="grid sm:grid-cols-3 gap-4 my-8">
        <div class="bg-white rounded-xl p-6 border border-slate-200 hover:border-green-500/50 transition-colors text-center">
          <p class="text-green-500 font-medium uppercase text-xs tracking-widest mb-2">1.</p>
          <p class="text-slate-900 text-xl font-bold mb-2">Mounir</p>
          <p class="text-3xl font-bold text-green-500">50:31</p>
        </div>
        <div class="bg-white rounded-xl p-6 border border-slate-200 hover:border-green-500/50 transition-colors text-center">
          <p class="text-green-500 font-medium uppercase text-xs tracking-widest mb-2">2.</p>
          <p class="text-slate-900 text-xl font-bold mb-2">Antoinette</p>
          <p class="text-3xl font-bold text-green-500">59:20</p>
        </div>
        <div class="bg-white rounded-xl p-6 border border-slate-200 hover:border-green-500/50 transition-colors text-center">
          <p class="text-green-500 font-medium uppercase text-xs tracking-widest mb-2">3.</p>
          <p class="text-slate-900 text-xl font-bold mb-2">Nickolas</p>
          <p class="text-3xl font-bold text-green-500">1:00:59</p>
        </div>
      </div>

      <p class="mb-6">Gratulerer til Mounir, Antoinette og Nickolas med en flott innsats! Det å fullføre 10 kilometer er en bragd i seg selv – og det å gjøre det sammen med klubbfølelse i hjertet er enda bedre.</p>

      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 text-lg italic">«Dette er bare begynnelsen. Social Run Club kommer garantert til å delta på flere løp i tiden fremover – og vi vil gjerne ha med deg!»</p>
        <p class="text-green-500 font-bold mt-3">– Social Run Club</p>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Bli en del av løpegruppen!</h2>
      <p class="mb-6"><a href="/social-run-club" class="text-green-500 hover:underline font-bold">Social Run Club</a> er en lavterskel løpegruppe der det handler om <strong class="text-green-500">fellesskap, energi og gode opplevelser sammen</strong>. Det spiller ingen rolle om du er nybegynner eller erfaren løper – alle er velkomne.</p>
    `,
    ctaButton: {
      label: 'Meld deg inn i Social Run Club',
      url: 'https://app.hoopit.io/join/veitvet-sportsklubb-532465/open?skipWelcome=true&push=true',
    },
  },
  {
    id: 4,
    slug: 'stig-jacobsen-honorart-lederstipend',
    title: 'Stig Jacobsen tildelt Honorært lederstipend',
    excerpt:
      'På Kretstinget i vår ble Stig Jacobsen tildelt det Honorære lederstipendet. Klubben mottok prisen på hans vegne og overrasket ham med utdelingen på vårt eget årsmøte i mars.',
    date: 'Mars 2026',
    sortDate: '2026-03-15',
    category: 'Klubbnyheter',
    image:
      'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/vrrxl0hb_Stig%20Jacobsen_%20Veitvet%20SK_Kretstinget%202026.jpg',
    imageStyle: 'cover',
    featured: false,
    content: `
      <p class="text-xl text-slate-600 mb-8">På Kretstinget i vår ble vår egen Stig Jacobsen tildelt det Honorære lederstipendet – en stor anerkjennelse for hans utrettelige arbeid for Veitvet Sportsklubb.</p>

      <p class="mb-6">Stig kunne dessverre ikke være til stede selv på Kretstinget, og <strong class="text-green-500">klubben mottok prisen på hans vegne</strong>. Vi visste at dette var noe vi ville markere ordentlig – og overraskelsen ble servert på vårt eget årsmøte i mars.</p>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">En velfortjent hyllest</h2>
      <p class="mb-6">Stig Jacobsen har gjennom mange år vist hva ekte klubbledelse handler om: tilstedeværelse, omsorg, struktur og en uvurderlig dedikasjon til både utøvere, frivillige og nærmiljøet. Hans innsats har formet Veitvet Sportsklubb gjennom flere generasjoner.</p>

      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 text-lg italic">«Stig er selve definisjonen på en klubbleder med hjerte. Det Honorære lederstipendet er en anerkjennelse han fortjener – og noe vi i Veitvet SK er utrolig stolte av.»</p>
        <p class="text-green-500 font-bold mt-3">– Veitvet Sportsklubb</p>
      </div>

      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Overraskelsen på årsmøtet</h2>
      <p class="mb-6">På årsmøtet i mars fikk Stig æren han fortjente – foran egne medlemmer, kolleger og venner av klubben. Det ble en høytidelig og rørende stund som vi sent vil glemme.</p>

      <p class="mb-6">Vi vil rette en stor takk til <strong class="text-green-500">Oslo Idrettskrets</strong> for tildelingen, og en enda større takk til Stig for alt han har bidratt med – og fortsetter å bidra med – for klubben vår.</p>

      <p class="text-2xl font-bold text-green-500">Gratulerer, Stig! Stipendet er vel fortjent.</p>
    `,
    gallery: [
      {
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/cawzevtb_IMG_0866.jpeg',
        alt: 'Stig Jacobsen mottar Honorært lederstipend på årsmøtet',
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/t50xq7n3_IMG_0872.jpeg',
        alt: 'Hyllest til Stig Jacobsen på Veitvet SKs årsmøte',
      },
    ],
  },
  {
    id: 1,
    slug: 'comet-sport-2026',
    title: 'Spennende nyhet – Veitvet SKs første signering i 2026!',
    excerpt:
      'Fra 1. januar 2026 har vi byttet utstyrsleverandør! Vi sier takk til Grasshoppa og Jako, og tar imot Comet Sport som ny leverandør og Umbro som vårt nye klesmerke. Medlemmer får 20% rabatt på klubbkolleksjonen!',
    date: '17. januar 2026',
    sortDate: '2026-01-17',
    category: 'Klubbnyheter',
    image:
      'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/40d2cu7y_Comet%20Sport%20logo.png',
    imageStyle: 'contain',
    featured: true,
    content: `
      <p class="text-xl text-slate-600 mb-8">Vi har gledelige nyheter å dele: Fra 1. januar 2026 har vi byttet utstyrsleverandør og sportsmerke!</p>
      
      <p class="mb-6">Vi sier takk til Grasshoppa og Jako, og tar imot <strong class="text-green-500">Comet Sport</strong> som ny leverandør og <strong class="text-green-500">Umbro</strong> som vårt nye klesmerke.</p>
      
      <p class="mb-6">Dette er en skikkelig oppgradering vi gleder oss stort til! Umbro er kjent for høy kvalitet, god passform og slitesterke materialer – noe som vil gi våre spillere og utøvere en bedre opplevelse både på trening og i kamp. Med Comet Sport som partner får vi i tillegg en moderne og brukervennlig løsning som kommer både klubben og dere medlemmer til gode.</p>
      
      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Hvem er Comet Sport?</h2>
      <p class="mb-6">Comet Sport Lillestrøm er Romerikes største leverandør av sportsutstyr til klubber, foreninger og bedrifter. De har egen klubbavdeling, grafisk avdeling for trykk av drakter, profileringstøy, russeklær, bannere, klistremerker m.m., og egen avdeling for premier og avslutningsmateriell.</p>
      
      <div class="bg-slate-100/50 rounded-xl p-6 my-8 border border-slate-200 dark:border-slate-700">
        <p class="text-slate-900 font-bold mb-2">📍 Besøksadresse:</p>
        <p class="text-slate-500 mb-2">Storgata 1, 2000 Lillestrøm</p>
        <p class="text-slate-600 dark:text-slate-300">Dere er hjertelig velkommen innom for å prøve den nye klubbkolleksjonen og se utvalget!</p>
      </div>
      
      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Ny klubbkolleksjon + nettbutikk</h2>
      <p class="mb-6">Alle medlemmer og ikke-medlemmer får <strong class="text-green-500">20 % rabatt</strong> på klubbkolleksjonen i nettbutikken.</p>
      
      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 font-bold mb-3">Slik handler du i nettbutikken:</p>
        <ol class="list-decimal list-inside space-y-2 text-slate-600 dark:text-slate-300">
          <li>Gå til <a href="https://cometsport.no/" target="_blank" rel="noopener noreferrer" class="text-green-500 hover:underline">cometsport.no</a></li>
          <li>Trykk «Logg inn»</li>
          <li>Lag bruker</li>
          <li>Gå til «Klubbkolleksjon»</li>
          <li>Scroll ned til Veitvet SK-logoen</li>
          <li>Klikk «mer info»</li>
        </ol>
      </div>
      
      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Eksklusive utstyrspakker!</h2>
      <p class="mb-6">I samarbeid med Comet Sport tilbyr vi en liten pakke og en stor pakke fra den nye Umbro-klubbkolleksjonen.</p>
    `,
    packages: [
      { name: 'Liten pakke', memberPrice: 'kr 700', description: 'Egenandel for medlemmer' },
      { name: 'Stor pakke', memberPrice: 'kr 1 200', description: 'Egenandel for medlemmer' },
    ],
    additionalInfo: `
      <p class="text-slate-600 mb-4"><strong class="text-slate-900 dark:text-white">Ikke-medlemmer</strong> får 30 % rabatt av ordinær pris.</p>
      <p class="text-green-500 font-bold">Tilbudet gjelder så langt lageret rekker – senest til og med 20. februar 2026.</p>
    `,
    orderInfo: {
      email: 'nickolas.paynter@veitvet-sportsklubb.no',
      instructions: [
        'Fullt navn på spilleren/medlemmet/ikke-medlemmet',
        'Hvilken pakke (Liten eller Stor)',
        'Ønskede initialer på tøyet (hvis ønskelig)',
        'Størrelser på alt utstyr',
      ],
      tip: 'Tips: Shortsen er noe liten i størrelsen – vurder å bestille 1–2 størrelser opp!',
      confirmation: [
        'Bekreftelse på mottatt bestilling',
        'Nøyaktig sum å betale',
        'Betalingsinformasjon',
      ],
    },
  },
  {
    id: 2,
    slug: 'ny-daglig-leder',
    title: 'Ny daglig leder i VSK – Velkommen Nickolas Paynter!',
    excerpt:
      'Vi er glade for å ønske Nickolas Paynter (39) velkommen som vår nye daglige leder! Han bringer med seg erfaring fra Chelsea FC og UEFA B-lisens. Les mer i Akers Avis Groruddalen.',
    date: '15. januar 2026',
    sortDate: '2026-01-15',
    category: 'Klubbnyheter',
    image:
      'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/0fhwxvdm_DL%20Paynter.jpg',
    imageStyle: 'cover',
    featured: false,
    content: `
      <p class="text-xl text-slate-600 mb-8">Vi er glade for å ønske Nickolas Paynter (39) velkommen som vår nye daglige leder!</p>
      
      <p class="mb-6">Nickolas Paynter bringer med seg en unik bredde av kompetanse til Veitvet Sportsklubb. Hans allsidighet spenner fra fotballtrening på høyt nivå til samfunnsarbeid og ungdomsutvikling.</p>
      
      <p class="mb-6">Han har utdanning fra både Norge og England, <strong class="text-green-500">UEFA B-lisens</strong> og erfaring som alt fra <strong class="text-green-500">International Development Coach for Chelsea Football Club</strong> til miljøterapeut og klubbleder.</p>
      
      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-slate-900 text-lg italic">«Jeg gleder meg enormt til å ta fatt på jobben og bli kjent med barna, foreldrene og alle andre i nærmiljøet på Veitvet. Det virker som et sted med sterkt samhold.»</p>
        <p class="text-green-500 font-bold mt-3">– Nickolas Paynter</p>
      </div>
      
      <p class="mb-6">Han startet i oktober 2025 i en 50% stilling og går over til fulltid etter nyttår.</p>
      
      <p class="text-2xl font-bold text-green-500">Velkommen til oss, Nickolas!</p>
    `,
    externalLinks: [
      {
        label: 'Les mer i Akers Avis Groruddalen',
        url: 'https://groruddalen.no/sport/fra-chelsea-til-veitvet-nickolas-paynter-klar-som-ny-daglig-leder/',
      },
      {
        label: 'Mer om Nickolas: «Chelsea og Veitvet er likere enn man tror»',
        url: 'https://groruddalen.no/sport/nickolas-39-chelsea-og-veitvet-er-likere-enn-man-tror/',
      },
    ],
  },
  {
    id: 3,
    slug: 'fotballakademi-fullbooket',
    title: 'Fotballakademi 2025/26 fullbooket – venteliste åpen',
    excerpt:
      'Veitvet SK Fotballakademi 2025/26 er fullbooket! Selv om det er fulltegnet, kan du fortsatt registrere deg og være på ventelisten.',
    date: '10. januar 2026',
    sortDate: '2026-01-10',
    category: 'Fotball',
    image:
      'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/fiqortth_Telenorxtra-crest-midblue-solid.png',
    imageStyle: 'contain',
    featured: true,
    content: `
      <p class="text-xl text-slate-600 mb-8">Veitvet SK Fotballakademi 2025/26 er fullbooket – bli med på venteliste nå!</p>
      
      <p class="mb-6">Selv om det er fulltegnet, kan du fortsatt registrere deg og være på ventelisten.</p>
      
      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Om Fotballakademiet</h2>
      <p class="mb-6">Fotballakademiet er et ekstratilbud utover vanlig klubbtrening. Det stilles krav til at den som melder seg på har skikkelig lyst til å utvikle seg og bli bedre i fotball.</p>
      
      <p class="mb-6">Vi forventer at spillere (og foreldre) prioriterer klubbtreninger dersom det blir overlapping. Spillere fra Veitvet SK skal alltid prioritere sine klubbøkter.</p>
      
      <div class="bg-slate-100/50 rounded-xl p-6 my-8 border border-slate-200 dark:border-slate-700">
        <p class="text-slate-900 font-bold text-xl mb-2">Pris</p>
        <p class="text-4xl font-bold text-green-500 mb-2">kr 2 000</p>
        <p class="text-slate-500 dark:text-slate-400">per år, per deltaker</p>
      </div>
      
      <h2 class="text-2xl font-bold text-slate-900 mt-10 mb-4">Inkludert i prisen</h2>
      <ul class="space-y-3 mb-8">
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Komplett treningsett
        </li>
        <li class="flex items-start gap-2 text-slate-600 dark:text-slate-300">
          <span class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
          Mulighet for ekstra aktiviteter (cuper, turneringer, arrangementer) – med egen deltakeravgift og påmeldingsinfo i forkant
        </li>
      </ul>
      
      <div class="bg-green-500/10 border border-green-500/30 rounded-xl p-6 my-8">
        <p class="text-green-500 font-bold text-lg mb-2">⚡ Plassene fylles raskt!</p>
        <p class="text-slate-600 dark:text-slate-300">Er det fullt, fortvil ikke! Registrer deg via lenken under for å bli satt på venteliste. Vi kontakter deg når en plass blir ledig.</p>
      </div>
    `,
    ctaButton: {
      label: 'Meld deg på ventelisten',
      url: 'https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-hst-25-var-26-833349',
    },
    contactEmail: 'fotballakademi@veitvet-sportsklubb.no',
  },
];

// Hjelpere
export const getAllNewsSorted = () =>
  [...newsArticles].sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate));

export const getLatestNews = (count = 3) => getAllNewsSorted().slice(0, count);

export const getNewsBySlug = (slug) => newsArticles.find((n) => n.slug === slug);
